export default "__VITE_ASSET__DF63S_eT__"